/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type kunde
 * @export
 */
export const Kundetype = {
    Forbruker: 'FORBRUKER',
    Bedrift: 'BEDRIFT'
} as const;
export type Kundetype = typeof Kundetype[keyof typeof Kundetype];


export function instanceOfKundetype(value: any): boolean {
    for (const key in Kundetype) {
        if (Object.prototype.hasOwnProperty.call(Kundetype, key)) {
            if (Kundetype[key as keyof typeof Kundetype] === value) {
                return true;
            }
        }
    }
    return false;
}

export function KundetypeFromJSON(json: any): Kundetype {
    return KundetypeFromJSONTyped(json, false);
}

export function KundetypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Kundetype {
    return json as Kundetype;
}

export function KundetypeToJSON(value?: Kundetype | null): any {
    return value as any;
}

export function KundetypeToJSONTyped(value: any, ignoreDiscriminator: boolean): Kundetype {
    return value as Kundetype;
}

